<template>
  <el-header class="appHeader">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="0" class="appHeader__logo">
        <router-link to="/">
          <img class="appHeader__logo__img" src="../assets/logo-couleur.svg" />
          <span class="appHeader__logo__title">Gamification Back-Office</span>
        </router-link>
      </el-menu-item>
      <el-submenu index="2">
        <template slot="title">Marketing activities</template>
        <el-menu-item index="2-1">
          <router-link to="/marketing/premium" class="el-menu-item__link">
            Premium activation
          </router-link>
        </el-menu-item>
        <el-menu-item index="2-2">
          <router-link to="/marketing/tips" class="el-menu-item__link">
            Tips of the day
          </router-link>
        </el-menu-item>
      </el-submenu>
      <el-menu-item index="3">
        <router-link to="/admin">
          Admin
        </router-link>
      </el-menu-item>

      <el-menu-item index="4" @click="signOut" class="el-menu__logout">
        Sign out
      </el-menu-item>
    </el-menu>
  </el-header>
</template>

<script>
export default {
  name: 'header',
  data() {
    return {
      activeIndex: '0',
    };
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
    },
    signOut() {
      this.$GoogleAuth.signOut().then(() => window.location.reload(false));
    },
  },
};
</script>

<style lang="sass" scoped>
.el-menu--popup
  background-color: #fcfcfd

.el-menu-item
  background-color: #fcfcfd
  &:hover
    background-color: #fff
    .el-menu-item__link
      color: #303133

  &__link
    color: #909399
    text-decoration: none

.appHeader
  padding: 0px

  .el-menu
    background-color: #fcfcfd

    &__logout
      position: absolute
      right: 0px

  &__logo
    line-height: 20px
    padding-top: 7px
    a
      text-decoration: none
    &__img
      display: block
      height: 27px
      margin-left: auto
      margin-right: auto
    &__title
      vertical-align: bottom

</style>



// WEBPACK FOOTER //
// src/components/Header.vue